// #region imports

// --- Angular
import { Component, EventEmitter, Input, Output } from '@angular/core';

// --- HS Code
import { GroupModel, LanguageModel, RespondentEmailValidationModel, RespondentModel, SurveyResponseModel } from '../../../models';

// #endregion

@Component({
  selector: 'hs-add-respondents-modal-v2',
  templateUrl: './add-respondents-modal-v2.component.html',
  styleUrls: ['./add-respondents-modal-v2.component.scss']
})
export class AddRespondentsModalV2Component {

onInvitePreviousRespondent() {
throw new Error('Method not implemented.');
}
onValidatingRespondentEmail($event: RespondentEmailValidationModel) {
throw new Error('Method not implemented.');
}
onModalDismissed($event: any) {
throw new Error('Method not implemented.');
}

  @Input() group: GroupModel | null = null;
  @Input() isAddMode: boolean = true;
  @Input() languages: LanguageModel[] | null = null;
  @Input() previousRespondents: RespondentModel[] | null = null;
  @Input() respondentIndex: number = 0;
  @Input() respondent: RespondentModel = {} as RespondentModel;
  @Input() response: SurveyResponseModel | null = null;
  @Input() respondentValidationResult: RespondentEmailValidationModel | null = null;
  @Input() validationErrorMessage: string = '';

  @Output() backButtonClicked = new EventEmitter();
  @Output() clearValidation = new EventEmitter();
  @Output() emailAddressChanged = new EventEmitter<RespondentEmailValidationModel>();
  @Output() invitePreviousClicked = new EventEmitter();
  @Output() saveRespondent = new EventEmitter<RespondentModel>();

  canAdd: boolean = false;

  onBackButtonClicked(): void {
    this.backButtonClicked.emit();
  }

  onSubmit(): void {

  }
}
